import { createBrowserRouter } from "react-router-dom";
import { DashboardPage } from "../features/dashboard/pages/dashboard.page";
import { projectsRoutes } from "./projects";
import { filmsRoutes } from "./films";
import { seriesRoutes } from "./series";
import { businessProfilesRoutes } from "./business-profiles";
import { professionalProfilesRoutes } from "./professional-profiles";
import { miscellaneousRoutes } from "./misc";
import { WithAuth } from "../components/layout/with-auth/with-auth.component";
import { ticketsRoutes } from "./tickets";
import { LoginPage } from "../features/login/pages/login.page";
export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: (
      <WithAuth>
        <DashboardPage />
      </WithAuth>
    ),
  },
  {
    path: "/projects",
    children: projectsRoutes,
  },
  {
    path: "/f",
    children: filmsRoutes,
  },
  { path: "/s", children: seriesRoutes },
  { path: "/b", children: businessProfilesRoutes },
  { path: "/p", children: professionalProfilesRoutes },
  { path: "/t", children: ticketsRoutes },
  ...miscellaneousRoutes,
]);
